import React, { useEffect, useState } from "react";

//kendo
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import kendo from "@progress/kendo-ui";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { Input } from "@progress/kendo-react-inputs";
import { BeatLoader } from "react-spinners";
import { getDevsInfo } from "../service/monitor/devlopersMonitorService";
import GridColumnInputFilter from "./com/gridFilter/gridColumnInputFilter";
import CustomFilter from "./com/gridFilter/custom_filter";
import { getUser } from "../service/authService";
import { useHistory } from "react-router";

const DevelopersMonitor = ({ conn, dongList }) => {
  const [dataSource, setDataSource] = useState([]);
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    cid: "",
    userTerm: "",
    meainStatCode: "",
  });
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  useEffect(() => {
    if (getUser().userTypeCode === 2005) getGridData();
    else {
      alert("권한이 없습니다.");
      history.push("/");
    }
  }, []);

  const getGridData = () => {
    setLoading(true);
    getDevsInfo(conn, dataState)
      .then(response => {
        setDataSource(response);
        setLoading(false);
      })
      .catch(error => {
        alert("에러, 관리자에게 문의하세요");
      });
  };

  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;
    dataState.skip = skip;
    dataState.take = take;
    getGridData();
  };

  // 그리드 필터링 처리
  const handleFilterChange = e => {
    console.log(e);
    // 필터 값 설정
    const isFilter = e.filter.filters[0];
    if (isFilter.field === "cid") {
      dataState.cid = isFilter.value;
    } else if (isFilter.field === "userTerm") {
      dataState.userTerm = isFilter.value;
    } else if (isFilter.field === "userStatus") {
      dataState.meainStatCode = isFilter.value.meainStatCode;
    } else if (isFilter.field === "managerTerm") {
      dataState.managerId = isFilter.value.userId;
      // 전화번호와 담당자 번호 탐색 및 분리
    }
    getGridData();
  };
  const userStatusCell = e => {
    const value = e.dataItem.userStatus;
    let result = "";
    if (value === "20001") {
      result = (
        <span>
          <img className="helpCircleSize" src="/images/chncareimg/icon_gre.png" alt="정상" /> 정상
        </span>
      );
    } else if (value === "20002") {
      result = (
        <span>
          <img className="helpCircleSize" src="/images/chncareimg/icon_yl.png" alt="경고" /> 경고
        </span>
      );
    } else if (value === "20003") {
      result = (
        <span>
          <img className="helpCircleSize" src="/images/chncareimg/icon_gray.png" alt="미작동" /> 미작동
        </span>
      );
    } else if (value === "20004") {
      result = (
        <span>
          <img className="helpCircleSize" src="/images/chncareimg/icon_rd.png" alt="위험" /> 위험
        </span>
      );
    }
    return <td>{result}</td>;
  };
  const latestNoneDtmCell = e => {
    const value = e.dataItem.latestNoneDtm;

    return <td>{value ? value : "자리비움 상태 아님"}</td>;
  };
  const meainList = [
    { meainStatCode: "20001", meainStatTerm: "정상" },
    { meainStatCode: "20002", meainStatTerm: "경고" },
    { meainStatCode: "20003", meainStatTerm: "미작동" },
    { meainStatCode: "20004", meainStatTerm: "위험" },
  ];
  const meainFilterDropDown = CustomFilter(meainList, { meainStatCode: "", meainStatTerm: "전체" }, "meainStatCode", "meainStatTerm", true, false);

  return (
    <div style={{ height: "85vh", border: "1px solid gainsboro" }}>
      <LocalizationProvider language="ko-KR">
        <IntlProvider locale="ko">
          <Grid
            style={
              loading
                ? {
                    opacity: 0.6,
                    pointerEvents: "none",
                    position: "relative",
                    height: "100%",
                  }
                : { height: "100%" }
            }
            data={dataSource.results}
            skip={dataState.skip}
            take={dataState.take}
            total={dataSource.total}
            filterable={true}
            onPageChange={handlePageChange}
            onFilterChange={handleFilterChange}
            pageable={{
              type: "numeric",
              pageSizes: [5, 10, 15, 20, 50],
              previousNext: true,
              buttonCount: 5,
            }}>
            <GridColumn field="cid" title="CID" filterCell={GridColumnInputFilter} />
            <GridColumn field="userTerm" title="대상자 이름" filterCell={GridColumnInputFilter} />
            <GridColumn field="userStatus" title="대상자 상태" filterCell={meainFilterDropDown} cell={userStatusCell} />
            <GridColumn field="latestGathDtm" title="데이터 마지막 수집시간" filterable={false} />
            <GridColumn field="latestNoneDtm" title="활동 이후 최초 자리비움 시간" cell={latestNoneDtmCell} filterable={false} />
            <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
          </Grid>
          {loading && (
            <p
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
              }}>
              <BeatLoader loading={true} size={24} color="#1e88e5" />
            </p>
          )}
        </IntlProvider>
      </LocalizationProvider>
    </div>
  );
};

export default DevelopersMonitor;
